import { render, staticRenderFns } from "./CreatePCS.vue?vue&type=template&id=31b5b9cc&scoped=true"
import script from "./CreatePCS.vue?vue&type=script&lang=js"
export * from "./CreatePCS.vue?vue&type=script&lang=js"
import style0 from "./CreatePCS.vue?vue&type=style&index=0&id=31b5b9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b5b9cc",
  null
  
)

export default component.exports